import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import NotFoundPage from '../pages/NotFoundPage';

@inject('packageStore')
@observer
export default class TicketItems extends Component {
  componentWillMount() {
    this.setTimerCount();
  }

  setTimerCount() {
    const {
      packageStore: {
        startTimerCount,
      }
    } = this.props;

    startTimerCount();
  }

  renderLogo = (imageUrl, channelNm) => {
    if (!imageUrl) {
      return (
        <span className="txt-logo">{channelNm}</span>
      )
    }
    return <img src={imageUrl} alt={channelNm} className="img-logo" />
  }

  render() {
    const {
      packageStore: {
        barcode,
        packageInfo,
        packageInfo: {
          time,
        },
        packageTimer,
      },
      tab,
    } = this.props;

    const baseLink = '/package/' + barcode;
    const logo = this.renderLogo(packageInfo.imageUrl, packageInfo.channelNm);

    if(!time) {
      return <NotFoundPage />
    }

    return (
      <header className="App-header">
        <h1 className="App-logo">
          {logo}
        </h1>
        { time.timer && !time.expired ?
          <div className="App-timer">
            <span className="name-timer">남은 시간</span>
            <span className="time-timer" id="timer">{packageTimer}</span>
          </div>
          : null 
        }
        <ul className="App-tab">
          <li className={ tab === 'shop' ? 'active' : null}>
            <Link 
              to={`${baseLink}`}
              className="btn-tab shop"
            >
              상품 이용권
            </Link>
          </li>
          <li className={ tab === 'benefit' ? 'active' : null}>
            <Link 
              to={`${baseLink}/benefit`}
              className="btn-tab benifit"
            >
              혜택 이용권
            </Link>
          </li>
          <li className={ tab === 'history' ? 'active' : null}>
            <Link 
              to={`${baseLink}/history`}
              className="btn-tab history"
            >
              내 티켓
            </Link>
          </li>
        </ul>
      </header>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/PackageHeader.jsx